import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImprovementPlanListDeleteResultApiModel, ImprovementPlanReasonApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class ImprovementPlanReasonsService extends CrudService<ImprovementPlanReasonApiModel, number> {
  public readonly apiUrl = 'improvement-plan-reasons';

  public deleteWithGuard(id: number): Observable<ImprovementPlanListDeleteResultApiModel> {
    return this.http.delete<ImprovementPlanListDeleteResultApiModel>(`${this.apiUrl}/delete/${id}`);
  }
}
